import React from 'react';
import styled from 'styled-components';
import {
  screenXsMin,
  spacer8,
  spacer20,
  Type,
  ButtonPrimary,
} from '@spotify-internal/encore-web';

import { useT } from 'client/i18n/hooks/useT';
import { COLOR_BLACK } from 'client/components/MarketingPagesShared/styles';
import OutboundLink from 'client/components/OutboundLink';
import { IntegrationRedirectScreenSection } from './styles';
import { VALID_VIDEO_PARTNERS } from '../constants';

const IntegrationRedirectScreenErrorContent = styled.div`
  margin: 0 auto;
  max-width: ${screenXsMin};
  padding: 0 40px;
  color: ${COLOR_BLACK};
  text-align: center;

  div {
    display: flex;
    flex-direction: column;
  }
`;

const RIVERSIDE_URL = 'https://riverside.fm/';

export function IntegrationRedirectScreenError({
  integrationName,
}: {
  integrationName: string;
}) {
  const t = useT();
  const { displayName } = VALID_VIDEO_PARTNERS[integrationName] || {};

  // TODO https://anchorfm.atlassian.net/browse/CAST-2750: Finalize and translate text when we have final copy
  return (
    <IntegrationRedirectScreenSection>
      <IntegrationRedirectScreenErrorContent>
        <Type as="h2" style={{ marginBottom: spacer8 }} variant="alto">
          {t(
            'IntegrationRedirectScreenError.Title',
            'Something went wrong',
            'The title for the Integration Redirect Screen when an error occurs due to an invalid partner or a partner not providing all of the necessary materials'
          )}
        </Type>
        <Type as="p" style={{ marginBottom: spacer20 }} variant="ballad">
          {t(
            'IntegrationRedirectScreenError.Body',
            'We didn’t get all the info we need to import your file. { returnToText }',
            'The body for the Integration Redirect Screen when an error occurs due to an invalid partner or a partner not providing all of the necessary materials',
            {
              returnToText: displayName
                ? t(
                    'IntegrationRedirectScreenError.PartnerBody',
                    'Please go back to { displayName } and try again.',
                    'The body for the Integration Redirect Screen when an error occurs due to a partner not providing all of the necessary materials informing the user to return to that partner',
                    { displayName }
                  )
                : '',
            }
          )}
        </Type>
        {displayName && (
          <OutboundLink to={RIVERSIDE_URL} newWindow>
            <ButtonPrimary>
              {t(
                'IntegrationRedirectScreenError.RedirectButton',
                'Go to { displayName }',
                'The body for the Integration Redirect Screen when an error occurs due to a partner not providing all of the necessary materials informing the user to return to that partner',
                { displayName }
              )}
            </ButtonPrimary>
          </OutboundLink>
        )}
      </IntegrationRedirectScreenErrorContent>
    </IntegrationRedirectScreenSection>
  );
}
